import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './keyboardKey.module.scss';
/** Represents a component for displaying a keyboard key. */
export const KeyboardKey = (props) => {
    var _a;
    return (_jsx("kbd", Object.assign({ className: classnames(styles.root, styles[(_a = props.variant) !== null && _a !== void 0 ? _a : 'rich']) }, { children: props.children })));
};
